module.exports = __webpack_public_path__ + "img/dead-grey-trunk-04.56d060fd.png";